import React from 'react';
import { Tooltip } from '@patternfly/react-core';
import { DateColumn, ReportViewType } from '../../types/reports';
import { AggregatedColumn } from '../../utils/reportHelpers';

interface MatrixHeaderProps {
  columns: DateColumn[];
  aggregatedColumns?: AggregatedColumn[] | null;
  viewType: ReportViewType;
  onResizeStart?: (e: React.MouseEvent) => void;
}

export const MatrixHeader: React.FC<MatrixHeaderProps> = ({
  columns,
  aggregatedColumns,
  viewType,
  onResizeStart,
}) => {
  // Render aggregated columns for weekly/monthly views
  const renderAggregatedHeaders = () => {
    if (!aggregatedColumns) return null;

    return aggregatedColumns.map((col) => {
      const tooltipContent = `${col.dates[0]} - ${col.dates[col.dates.length - 1]}`;
      return (
        <Tooltip key={col.key} content={tooltipContent}>
          <div className="matrix-cell matrix-cell--header matrix-cell--aggregated">
            <div className="matrix-header__day-name">{col.label}</div>
            {col.subLabel && <div className="matrix-header__day-number">{col.subLabel}</div>}
          </div>
        </Tooltip>
      );
    });
  };

  // Render daily columns
  const renderDailyHeaders = () => {
    return columns.map((col) => {
      const classNames = [
        'matrix-cell',
        'matrix-cell--header',
        col.isWeekend ? 'matrix-cell--weekend' : '',
        col.isToday ? 'matrix-cell--today' : '',
      ]
        .filter(Boolean)
        .join(' ');

      return (
        <Tooltip key={col.date} content={col.date}>
          <div className={classNames}>
            <div className="matrix-header__day-name">{col.dayName}</div>
            <div className="matrix-header__day-number">{col.dayNumber}</div>
          </div>
        </Tooltip>
      );
    });
  };

  return (
    <div className="matrix-header">
      <div className="matrix-cell matrix-cell--label">
        <span>Name</span>
        {onResizeStart && (
          <div
            className="matrix-cell__resize-handle"
            onMouseDown={onResizeStart}
            title="Drag to resize column"
          />
        )}
      </div>
      <div className="matrix-cell matrix-cell--labels-header">Labels</div>
      <div className="matrix-cell matrix-cell--total-header">Total</div>
      {viewType === 'daily' ? renderDailyHeaders() : renderAggregatedHeaders()}
      <div className="matrix-cell matrix-cell--total-header">Total</div>
    </div>
  );
};
